(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["es-lp-promo-strip"] && !Shopify.designMode) return;
  try {
    
(function () {
  if (window.__esCopyBound) return;
  window.__esCopyBound = true;
  function copy(text) {
    if (navigator.clipboard && window.isSecureContext) return navigator.clipboard.writeText(text);
    return new Promise(function (res) {
      var t = document.createElement('textarea'); t.value = text; t.setAttribute('readonly', '');
      t.style.position = 'fixed'; t.style.opacity = '0'; document.body.appendChild(t); t.select();
      try { document.execCommand('copy'); } catch (e) {} t.remove(); res();
    });
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-es-copy]'); if (!b) return;
    var code = b.getAttribute('data-es-copy'), label = b.dataset.label || b.textContent;
    b.dataset.label = label;
    copy(code).then(function () {
      b.textContent = b.dataset.copied || 'Copied';
      b.classList.add('is-copied');
      var scope = b.closest('[data-es-copy-scope]'), live = scope && scope.querySelector('[data-es-live]');
      if (live) live.textContent = 'Discount code ' + code + ' copied to clipboard';
      clearTimeout(b._t);
      b._t = setTimeout(function () { b.textContent = label; b.classList.remove('is-copied'); if (live) live.textContent = ''; }, 2500);
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
